var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"content py-md-4"},[_c('div',{staticClass:"container padded-content"},[_c('PageSlide',[_c('router-view')],1)],1)]),(_vm.isDebug)?_c('DebugLayer'):_vm._e(),_c('UserSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }